const supplierLayout = {
  quotation: 'Yêu cầu',
  pendingQuotation: 'Đang chờ báo giá',
  resolveQuotation: "Báo giá",
  other: 'Khác',
  purchaseOrder: 'Đặt hàng',

  login: 'Đăng nhập',
  loginTitle: "Đăng nhập vào WMS",
  acntNotExist: ' Tài khoản không tồn tại, vui lòng kiểm tra',
  acntNotAvailable: ' Tài khoản đã tồn tại hoặc bị vô hiệu hóa',
  loginFail: "Đăng nhập thất bại",
  updatePwd: "Thay đổi mật khẩu",
  pwd: 'Mật khẩu',
  inputPwd: "Vui lòng nhập mật khẩu.",
  inputAct: "Vui lòng nhập tài khoản",
  inputPwdSec: "Vui lòng nhập lại mật khẩu.",
  confirmPwd: ' Xác nhận mật khẩu',
  logOut: "Thoát đăng nhập",
  logOutTipTitle: 'Xác định thoát khỏi đăng nhập sao?',
  logOutTipContent: "Bạn sẽ quay lại trang đích khi bạn đã xác định thoát.",
  confirmTip: "Bạn có chắc chắn muốn từ chối lời đề nghị này?",
  confirmTip2: "Sau khi báo giá, người mua sẽ nhận được báo giá của bạn và có thể chấp nhận hoặc từ chối báo giá của bạn",
  pwdError: "Sửa đổi mật khẩu không thành công",
  editPwd: "Thay đổi mật khẩu",
  searchByKeyword: "Nhập từ khóa tìm kiếm",
  accountErr:"Tài khoản hoặc mật khẩu sai",
  deliveryNotice:'Thông báo giao hàng',
  business:'Kinh doanh',
  reconciliation: 'đối chiếu',
  contract: "Quản lý hợp đồng",
  quotations:'báo giá',
  proQuotations:'Báo giá hàng hóa',
  myQuotations:'Báo giá của tôi',
};

export default supplierLayout;